<template>
  <div style="padding: 20px">
    <div style="padding-bottom: 20px">
      <select-area @areaListId="getAreaListId"/>
      <el-date-picker
          v-model="query.yearAndMonth"
          type="month"
          style="width: 160px;margin-right: 10px"
          value-format="YYYY-MM"
          placeholder="年月选择">
      </el-date-picker>
      <el-button type="primary" @click="selectTableData()">搜索</el-button>
      <el-popconfirm @confirm="exportReturnVisitRate" title="确定要导出吗？">
        <template #reference>
          <el-button v-permission="['ReturnVisitRate:export']" type="primary" icon="Download">导出</el-button>
        </template>
      </el-popconfirm>
    </div>
    <el-table
        v-loading="tableLoading"
        :data="tableData"
        border
        :row-style="{ height: '20px' }"
        :cell-style="{ padding: '16px' }"
        class="table"
        ref="multipleTable"
        header-cell-class-name="table-header">
      <el-table-column prop="region" label="城市"></el-table-column>
      <el-table-column prop="regionType" label="城市类型"></el-table-column>
      <el-table-column prop="areaName" label="校区"></el-table-column>
      <el-table-column prop="monthCount" label="上课人数"></el-table-column>
      <el-table-column prop="returnVisitCount" label="回访人数"></el-table-column>
      <el-table-column prop="rateStr" label="回访率"></el-table-column>
      <el-table-column label="详情" width="100" fixed="right" align="center">
        <template #default="scope">
          <el-button @click="detailDialog=true , detail = scope.row.list" size="small" style="padding: 0;margin: 0" type="text">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="query.pageIndex"
          :page-size="query.pageSize"
          :total="query.pageTotal"
          @current-change="handlePageChange"
      ></el-pagination>
    </div>
    <el-dialog
        title="详情"
        draggable
        v-model="detailDialog"
        width="1300px">
      <el-table height="500px"
                :data="detail"
                border
                class="table"
                ref="multipleTable"
                :row-style="{ height: 10 + 'px' }"
                :cell-style="{ padding: 5 + 'px' }"
                header-cell-class-name="table-header"
      >
        <el-table-column prop="region" label="城市" show-overflow-tooltip />
        <el-table-column prop="regionType" label="城市类型" show-overflow-tooltip />
        <el-table-column prop="name" label="学员姓名" show-overflow-tooltip />

        <el-table-column prop="orderId" label="主ID" show-overflow-tooltip />
        <el-table-column prop="courseRecordId" label="课时ID" show-overflow-tooltip />
        <el-table-column prop="courseTime" label="上课时间" show-overflow-tooltip />
        <el-table-column prop="campusName" label="实际上课校区" show-overflow-tooltip />
        <el-table-column prop="followId" label="回访ID" show-overflow-tooltip />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import selectArea from "../../components/SelectArea";
import {selectReturnVisitRatePage,exportReturnVisitRate} from "@/api/follow";
export default {
  name: "ReturnVisitRate",
  components: {
    selectArea
  },
  data() {
    return {
      tableData:[],
      tableLoading:false,
      detail:[],
      detailDialog:false,
      query: {
        areaIdList:[],
        pageIndex: 1,
        pageSize: 10,
        pageTotal:0,
        year:null,
        month:null,
        yearAndMonth:null
      }
    }
  },
  methods:{
    getAreaListId(val) {
      this.query.areaIdList = val;
    },
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.selectTableData();
    },
    exportReturnVisitRate(){
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      exportReturnVisitRate(this.query).then(val=>{
        if (val.code == 200) {
          this.$message.success("下载中，请稍后前往右上角下载中心查看！");
        }else {
          this.$message.error(val.message);
        }
      });
    },
    selectTableData(){
      this.tableLoading = true;
      [this.query.year, this.query.month] = this.query.yearAndMonth ? this.query.yearAndMonth.split('-') : [null, null];
      selectReturnVisitRatePage(this.query).then(val=>{
        if (val.code == 200) {
          this.tableLoading = false;
          this.tableData = val.data.records;
          this.query.pageTotal = val.data.total;
        } else {
          this.$message.error("获取表格数据失败");
        }
      })
    }
  },
  created() {
    this.selectTableData();
  }
}
</script>

<style scoped>

</style>